// Identity + request fields for the user news-container API
// (/mycontainers, /container, /container/delete, /containers/order).
//
// Mirrors models/NewsPin.js: a fully-initialised class instance, so the
// undefined-replacer trick used at the call site (see usercontainer.service.js,
// same replacer as NewsSaveButton.handlePin in components/Item.js) turns an
// absent field into "" instead of dropping it from the JSON payload.
//
// `name` is the caller's SURNAME - exactly the same identity block as PinDTO.
// The container's own title is the separate `title` field; the two are not
// interchangeable.
export class UserContainerClass {
    constructor() {
        // identity block - the only five identity fields the API documents
        this.uuid = "";
        this.firstname = "";
        this.name = "";
        this.email = "";
        this.displayname = "";
        // per-operation fields; each service call projects to just the ones
        // its endpoint documents, so these are never sent where unexpected
        this.title = "";
        this.language = "";
        this.id = "";
    }
}
